import { JSDOM } from "jsdom";
import { getErrorMessageSetter, getInputElements, handleDisabledElements } from "./utils";
import { elementsSelectors as supportedElementTags } from "./supported-elements-selectors";
import { formGroupRadioButtons } from "./form-test-templates";

describe("form-utils", () => {
    it("handles disabled element correctly", () => {
        const dom = new JSDOM();
        dom.window.document.body.insertAdjacentHTML(
            "afterbegin",
            `
            <div class="wrapper">
                ${supportedElementTags.map((elementTag: string) => {
                    return `<${elementTag} name="${elementTag}"></${elementTag}>`;
                })}
            </div>
        `
        );
        const wrapper = dom.window.document.querySelector(".wrapper");
        handleDisabledElements(wrapper, supportedElementTags, true);
        const selectorTags = supportedElementTags.join(", ");
        const supportedElements = dom.window.document.querySelectorAll(selectorTags);
        supportedElements.forEach((element: HTMLElement) => {
            expect(element).toHaveAttribute("disabled");
        });
        handleDisabledElements(wrapper, supportedElementTags, false);
        supportedElements.forEach((element: HTMLElement) => {
            expect(element).not.toHaveAttribute("disabled");
        });
    });

    it("gets the right number of ux input elements", async () => {
        const dom = new JSDOM();
        dom.window.document.body.insertAdjacentHTML(
            "afterbegin",
            `
            <div class="wrapper">
                ${supportedElementTags.map((elementTag: string) => {
                    return `
                        <${elementTag} name="${elementTag}"></${elementTag}>
                    `;
                })}
                ${formGroupRadioButtons()}
            </div>
        `
        );
        const wrapper = dom.window.document.querySelector(".wrapper");
        const getInputs = getInputElements({
            container: wrapper,
            supportedElements: supportedElementTags
        });
        expect(getInputs.length).toBe(11);
    });

    it("returns the error message setter function", async () => {
        const dom = new JSDOM();
        dom.window.document.body.insertAdjacentHTML(
            "afterbegin",
            `
            <ux-form>
                <ux-input-field
                    name="test"
                    required
                    data-validation-required--msg="This field is required"
                >
                </ux-input-field>
            </ux-form>
            `
        );
        const uxForm = dom.window.document.querySelector("ux-form");
        const uxInput = dom.window.document.querySelector("ux-input-field");
        expect(
            typeof getErrorMessageSetter({
                uxInputElement: uxInput,
                uxForm: uxForm
            })
        ).toBe("function");
    });
});
